import isNil from 'lodash-es/isNil'

import { DRAG_DROP_DEFAULT_CONFIG } from '../../../../DragDrop'
import { CALENDAR_GRID_SNAP_MINUTES } from '../../../CalendarGrid.constants'
import { getCalendarGridSelectionBounds } from '../../../CalendarGrid.utils'
import { getCalendarGridDayTime } from '../../../CalendarGrid.utils.time'

function getCalendarGridWeekSelectionStep(minutes) {
  return Math.floor(minutes / CALENDAR_GRID_SNAP_MINUTES)
}

// A press turns into a drag at the distance that starts moving an entry, so a shaky click still takes the hour
function getIsCalendarGridWeekSelectionDrag({ pointerY, selection }) {
  const distance = Math.abs(pointerY - selection.anchorPointerY)

  return (
    selection.isDrag || distance >= DRAG_DROP_DEFAULT_CONFIG.activationDistance
  )
}

function getCalendarGridWeekMovedSelection({ minutes, pointerY, selection }) {
  const focus = getCalendarGridWeekSelectionStep(minutes)
  const isDrag = getIsCalendarGridWeekSelectionDrag({ pointerY, selection })

  const isChanged = focus !== selection.focus || isDrag !== selection.isDrag

  return isChanged ? { ...selection, focus, isDrag } : selection
}

export function toCalendarGridWeekSelection({ day, minutes, pointerY, start }) {
  const step = getCalendarGridWeekSelectionStep(minutes)

  return {
    anchor: step,
    anchorPointerY: pointerY,
    anchorStart: start,
    day,
    focus: step,
    isDrag: false,
  }
}

export function getCalendarGridWeekNextSelection({
  day,
  minutes,
  pointerY,
  selection,
}) {
  return selection?.day === day
    ? getCalendarGridWeekMovedSelection({ minutes, pointerY, selection })
    : selection
}

export function getHasCalendarGridWeekSelectionRange(selection) {
  return !isNil(selection) && selection.isDrag
}

// Every quarter-hour the drag touched, so the span covers it (CAL-02 §7.3 rule 5)
export function getCalendarGridWeekSelectionRange({ selection, timezone }) {
  const { day } = selection

  const { from, to } = getCalendarGridSelectionBounds(selection)

  return {
    end: getCalendarGridDayTime({
      day,
      minutes: to * CALENDAR_GRID_SNAP_MINUTES + CALENDAR_GRID_SNAP_MINUTES,
      timezone,
    }),
    start: getCalendarGridDayTime({
      day,
      minutes: from * CALENDAR_GRID_SNAP_MINUTES,
      timezone,
    }),
  }
}

export function getCalendarGridWeekSelectionItem({ selection, timezone }) {
  const range = getHasCalendarGridWeekSelectionRange(selection)
    ? getCalendarGridWeekSelectionRange({ selection, timezone })
    : null

  return range
    ? {
        date: selection.day,
        end: range.end.toISOString(),
        start: range.start.toISOString(),
      }
    : null
}
